export default __webpack_public_path__ + "static/media/icon_payment_type_kiosk.c095745d.svg";